/** Snackbar copy when launch/submit is blocked by incomplete required intake fields. */
export const COMPLETE_REQUIRED_INTAKE_QUESTIONS_MSG = 'Complete all required intake questions';
